<template>
    <div>
        <attached-fs-modal ref="fs-modal"></attached-fs-modal>
        <ui-crud title="Site Instructions" subtitle="A list of site instructions for this package"
                 ref="crud"
                 :fetch="fetch" :pipe-with="pipeItems"
                 :group-by="groupByStatus">
            <template #new-button>
                <div class="flex items-center">
                    <h1 class="text-lg font-medium text-gray-900">Site Instructions</h1>
                    <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus"
                                   @click.prevent="createNew()">New
                    </ui-button-new>
                </div>
                <p class="mt-1 text-sm text-gray-600">All Site Instructions for this package</p>
                <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus"
                               @click.prevent="createNew()">New
                </ui-button-new>
            </template>

            <!-- Filters. -->
            <template #filters>
                <div class="relative">
                    <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                    <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </template>

            <!-- List item. -->
            <template #list-item="{ item, select, active, setEditMode }">
                <ui-crud-card
                    :title="'SI-'+(('000'+item.referenceNumber).slice(-3))"
                    :subtitle="item.formatted_date"
                    :metadata="item.status"
                    :active="active"
                    @click="selectItem(item,select,setEditMode)"
                ></ui-crud-card>
            </template>

            <!-- Create form. -->
            <template #create="{ addItem, setEditMode, selectItem }">
                <div class="flex space-x-8 pt-4 px-4 m-4 justify-center items-center">
                    <div
                        class="border border-grey-200 rounded-l bg-gray-50 w-full h-full p-4 justify-center items-center text-center text-gray-500">
                        <-- Please select an existing Site Instruction to view/edit or click new to create a new one.
                    </div>
                </div>
            </template>

            <template #edit="{ selectedItem, setEditMode, removeItem }">
                <site-instructions-edit
                    :package-reference="packageReference" :package-name="packageName"
                    :item="selectedItem"
                    :removeItem="removeItem"
                    :fs-modal="$refs['fs-modal']"
                ></site-instructions-edit>
            </template>

            <!-- Show page. -->
            <template #show="{ selectedItem, setEditMode, removeItem, addItem, selectItem }">

            </template>
        </ui-crud>
    </div>
</template>

<script>
import {SiteInstruction} from "@models";
import SiteInstructionsEdit from "./SiteInstructionsEdit.vue";
import UiInput from "../../ui/UiInput.vue";
import UiCrudCard from "../../ui/UiCrudCard.vue";
import UiCrud from "../../ui/UiCrud.vue";
import {uuid} from "../../../utils";

export default {
    components: {UiCrud, UiCrudCard, UiInput, SiteInstructionsEdit},
    props: {
        packageReference: null,
        legacyPackageId: null,
        packageName: null,
        admin: Boolean,
        showWhenLoaded: null
    },
    data() {
        return {
            search: '',
            contacts: {data: [], loaded: false},
            items: [],
        }
    },
    methods: {
        async createNew() {
            let id = uuid();
            try {
                await SiteInstruction.create(this.packageReference, id)
                await this.$refs.crud.fetchItems();
                this.$refs.crud.selectItem(this.$refs.crud.items.find((i) => i.id === id), true);
            } catch (error) {
                let body = JSON.parse(error.request.response);
            }
        },
        getItemTitle(item) {
            if (item.status === 'Draft') {
                return '<span class="text-gray-400">Draft #' + item.referenceNumber + '</span> - ' + item.formatted_date;
            }
            return '#' + item.referenceNumber + ' - ' + item.formatted_date;
        },
        selectItem(item, select, setEditMode) {
            select()
            setEditMode(true)
        },
        async fetch() {
            return await SiteInstruction.list(this.packageReference)
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((pr) => {
                    return query.every((token) => {
                        return pr.tokens.includes(token);
                    })
                });
            }
            return items;
        },
        groupByStatus(item) {
            return item.status;
        },
    },
    async mounted() {
    }
}
</script>